export default {
    componentUpdated: el => {
        function loadImage() {
            el.classList.remove("loaded")
            const imageElement = Array.from(el.children).find(el => el.nodeName === "IMG");
            if (imageElement) {
                imageElement.addEventListener("load", () => {
                    setTimeout(() => el.classList.add("loaded"), 50);
                });
                imageElement.addEventListener("error", () => {

                });
                imageElement.src = imageElement.dataset.url;
            }
        }

        loadImage();
    }
};
